import { ICommonCallbackPayload } from 'types/common';

import { actionStringGenerator, createPayloadAction } from '../helpers';
import { StandardAction } from '../types';
import { IFileActionDispatchPayload, IUploadDocument } from './types';

export default class FileAction {
  static TYPES = {
    // Async actions
    // -- Fetch file
    FETCH_FILE: actionStringGenerator('file', 'FETCH_FILE'),
    UPLOAD_FILE: actionStringGenerator('file', 'UPLOAD_FILE'),
    UPLOAD_DOCUMENT: actionStringGenerator('document', 'UPLOAD_DOCUMENT'),
  };

  // Upload file - placeholder => type: any
  static uploadFileStart = (
    data: IFileActionDispatchPayload,
    callback?: ICommonCallbackPayload,
  ): StandardAction<{ data: IFileActionDispatchPayload; callback?: ICommonCallbackPayload }> =>
    createPayloadAction(FileAction.TYPES.UPLOAD_FILE.START, { data, callback });

  static uploadFileSuccess = (): StandardAction => createPayloadAction(FileAction.TYPES.UPLOAD_FILE.SUCCESS);

  static uploadFileError = (error?: string): StandardAction =>
    createPayloadAction(FileAction.TYPES.UPLOAD_FILE.FAILURE, undefined, undefined, error);

  static uploadDocumentStart = (
    data: IUploadDocument,
    callback?: ICommonCallbackPayload,
  ): StandardAction<{ data: IUploadDocument; callback?: ICommonCallbackPayload }> =>
    createPayloadAction(FileAction.TYPES.UPLOAD_DOCUMENT.START, { data, callback });
}
